// Copyright (c) 2017 Deere & Company

import DebitSpecialAllowancePanel from './debit-special-allowance-panel';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    specialAllowancePartialDebit: state.tcsm.partialDebit.debit.specialAllowancePartialDebit
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => {

    const {updateCompanyContribution} = dispatchProps;

    return {
        ...stateProps,
        actions: {
            updateCompanyContribution
        }
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DebitSpecialAllowancePanel);



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-special-allowance-panel/index.js